import { Component } from '@angular/core';

@Component({
    selector: 'cmps-event-centre-card-message',
    template: ` <div class="cmps-event-centre-card-message--left">
            <ng-content select="[cmpsEventCentreCardTarget]"></ng-content>
            <ng-content></ng-content>
            <ng-content select="[cmpsEventCentreCardTimestamp]"></ng-content>
        </div>
        <div class="cmps-event-centre-card-message--right">
            <ng-content select="cmps-event-centre-card-actions"></ng-content>
        </div>`,
    host: {
        class: 'cmps-event-centre-card-message',
    },
})
export class CardMessageComponent {}
